import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import StyleDrawerProps from "./../useInterfaces/MDDrawerInterface"

export default styled(Drawer)<StyleDrawerProps>(({ theme, ownerState,ownerloyaut }) => {
  const palette = theme?.palette;
  const functions = theme?.functions;
  const transitions = theme?.transitions;
  const breakpoints = theme?.breakpoints;
  const boxShadows = theme?.boxShadows;

  const { transparentSidenav, whiteSidenav, miniSidenav, darkMode } = ownerState;
  const { mt=0, mb=0, mr=0, ml=0, pt=0, pb=0, pr=0, pl=0,br=0, wth=250} = ownerloyaut;

  const height= "calc(100vh - 2rem)";
  const { transparent, gradients, white, background } = palette||{};
  const { xxl } = boxShadows||{};
  const { pxToRem, linearGradient } = functions||{};

  let backgroundValue = darkMode
    ? background.sidenav
    : linearGradient(gradients.dark.main, gradients.dark.state);

  if (transparentSidenav) {
    backgroundValue = transparent.main;
  } else if (whiteSidenav) {
    backgroundValue = white.main;
  }

  // styles for the sidenav when miniSidenav={false}
  const drawerOpenStyles = () => ({
    background: backgroundValue,
    transform: "translateX(0)",
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      boxShadow: transparentSidenav ? "none" : xxl,
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: wth,
      height: height,
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
  });

  // styles for the sidenav when miniSidenav={true}
  const drawerCloseStyles = () => ({
    background: backgroundValue,
    transform: `translateX(${pxToRem(-320)})`,
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      boxShadow: transparentSidenav ? "none" : xxl,
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: pxToRem(96),
      height: height,
      overflowX: "hidden",
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
    },
  });

  return {
    "& .MuiDrawer-paper": {
      boxShadow: xxl,
      border: "none",
      marginTop: mt,
      marginButtom: mb,
      marginRight: mr,
      marginLeft: ml,
      paddingTop:pt,
      paddingButtom: pb,
      paddingRight: pr,
      paddingLeft: pl,
      borderRadius:br,
      position: "relative",

      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  };
});
